import React, { useState } from 'react';
import styles from './Issue.module.css';
import { addIssue } from '../../Fetch/fetchIssue';

const Issue = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    subject: '',
    text: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState(''); // 'success' or 'error'

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);
  setMessage('');
  setMessageType('');

  try {
    // If addIssue returns parsed JSON directly
    const responseData = await addIssue(formData);
    
    // Display the message from the server
    setMessage(responseData.message || 'פנייתך התקבלה ונחזור אליך בהקדם');
    setMessageType('success');
    
    // Clear the form
    setFormData({
      fullName: '',
      email: '',
      phone: '',
      subject: '',
      text: ''
    });

    // Scroll to top to show the success message
    window.scrollTo({ top: 0, behavior: 'smooth' });
        
  } catch (error) {
    // Handle different types of errors
    if (error.message) {
      setMessage(error.message);
    } else {
      setMessage('אירעה שגיאה בשליחת הפניה. אנא בדוק את החיבור לאינטרנט ונסה שנית.');
    }
    setMessageType('error');
  } finally {
    setIsSubmitting(false);
  }
};

  return (
    <div className={styles.container}>
      <div className={styles.formWrapper}>
        <h1 className={styles.title}>פתיחת קריאת עזרה</h1>
        <p className={styles.subtitle}>נשמח לעזור לך. אנא מלא את הפרטים הבאים:</p>
        
        {/* Display message at the top when available */}
        {message && (
          <div className={`${styles.message} ${messageType === 'success' ? styles.success : styles.error}`}>
            {messageType === 'success' && (
              <div className={styles.successIcon}>✓</div>
            )}
            <div className={styles.messageText}>{message}</div>
            {messageType === 'success' && (
              <div className={styles.successDetails}>
                <p>נציג ועד הבית יחזור אליך תוך 24-48 שעות</p>
              </div>
            )}
          </div>
        )}
        
        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.formGroup}>
            <label htmlFor="fullName" className={styles.label}>שם מלא *</label>
            <input
              type="text"
              id="fullName"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              className={styles.input}
              required
              placeholder="הכנס את שמך המלא"
            />
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="email" className={styles.label}>כתובת אימייל *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className={styles.input}
              required
              placeholder="example@email.com"
            />
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="phone" className={styles.label}>מספר טלפון</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className={styles.input}
              placeholder="050-1234567"
            />
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="subject" className={styles.label}>נושא הפניה *</label>
            <input
              type="text"
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              className={styles.input}
              required
              placeholder="תאר בקצרה את הבעיה או השאלה"
            />
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="text" className={styles.label}>פירוט הפניה</label>
            <textarea
              id="text"
              name="text"
              value={formData.text}
              onChange={handleChange}
              className={styles.textarea}
              rows="6"
              placeholder="אנא פרט את הבעיה או השאלה שלך כאן..."
            />
          </div>

          <button 
            type="submit" 
            className={styles.submitButton}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'שולח...' : 'שלח פניה'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Issue;